import asyncSweetScroll from '@/helpers/sweet_scroll';

pageLoad('pages_promo', () => {
  $('.b-top_menu-popup.is-promo button[data-scroll-to]').on('click', ({ currentTarget }) => {
    $(currentTarget)
      .closest('.b-top_menu-popup')
      .trigger('modal:hide');

    asyncSweetScroll(currentTarget.getAttribute('data-scroll-to'));
  });

  $('.b-top_menu-popup.is-promo .to-contacts').on('click', ({ currentTarget }) => {
    $(currentTarget)
      .closest('.b-top_menu-popup')
      .trigger('modal:hide');

    $('.b-top_menu.v4 .support-phone').click();
  });
});
